import { Injectable, inject } from '@angular/core';
import { PopupItem } from './popup-item';
import { COBVerifyOtpFormComponent } from 'src/app/rcob/cob-verify-otp-form/cob-verify-otp-form.component';
import { Subject, takeUntil } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FpxModal } from '@fpx/core';
import { ComponentType } from '@angular/cdk/portal';
import { ErrorAlertComponent } from 'src/app/rcob/error-alert/error-alert.component';
import { ProductRequestTypeAlertComponent } from 'src/app/rm/product-request-type-alert/product-request-type-alert.component';
import { ApplicantTypeAlertComponent } from 'src/app/rm/components/applicant-type-alert/applicant-type-alert.component';
import { RloApplicationFilterFormComponent } from 'src/app/rm/rloapplication-filter-form/rloapplication-filter-form.component';
import { RloApplicationSearchFormComponent } from 'src/app/rm/rlo-application-search-form/rlo-application-search-form.component';
import { RloApplicationSortFormComponent } from 'src/app/rm/rlo-application-sort-form/rlo-application-sort-form.component';


@Injectable({
  providedIn: 'root',
})
export class PopupService {

  private _matDialog: MatDialog = inject(MatDialog);
  private _destroy$: Subject<any> = new Subject();
  private modalRef: MatDialogRef<any>;

  getPopup(path) {
    let children: PopupItem;
    switch (path) {
 
            case 'verify-otp':
        children = new PopupItem(COBVerifyOtpFormComponent, {});
        break;
      // case 'OPENNEWCA':
      //   children = new PopupItem(OpenNewCurrentAccountComponent, {});
      //     break;
      // case 'OPENNEWSA':
      //   children = new PopupItem(OpenNewSavingsAccountComponent, {});
      //     break;
      // case 'OPENNEWDA':
      //   children = new PopupItem(OpenNewDepositComponent, {});
      //     break;
    }

    return children;
  }

  getComponent(path) {
    let _component: ComponentType<any>;
    switch (path) {
      case 'rcob/verify-otp':
        _component = COBVerifyOtpFormComponent;
        break;
      case 'rcob/error-alert':
        _component = ErrorAlertComponent;
        break;
      case 'product-request-type':
        _component = ProductRequestTypeAlertComponent;
        break;
        case 'applicant-type':
          _component = ApplicantTypeAlertComponent;
        break;
        case 'rloapplication-filter-form':
          _component=RloApplicationFilterFormComponent;
        break;
        case 'rlo-application-search-form':
          _component=RloApplicationSearchFormComponent;
        break;
        case 'rlo-application-sort-form':
          _component=RloApplicationSortFormComponent;
        break;
    }
    return _component;
  }

  getModelInstance():MatDialogRef<any> | null{
    return this.modalRef || null;
  }

  public openModal<T>(modalConfig: FpxModal<T>) {
    if (modalConfig.getComponent()) {
      this.modalRef = this._matDialog.open(modalConfig.getComponent(), {
        data: modalConfig.getData(),
        backdropClass: modalConfig.getBackDropClass(),
        closeOnNavigation: modalConfig.getCloseOnNavigation(),
        disableClose: modalConfig.getDisableClose(),
        height: modalConfig.getHeight(),
        width: modalConfig.getWidth(),
        id: modalConfig.getId(),
        autoFocus: modalConfig.getAutoFocus(),
        panelClass: modalConfig.getPanelClass()
      });

      this.modalRef
        .afterClosed()
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (res: any) => {
            if (modalConfig.getAfterClosed()) {
              modalConfig.getAfterClosed()?.(res);
            }
          },
          error: (err: any) => {
            console.log(err);
          },
          complete: () => {},
        });

        this.modalRef
        .afterOpened()
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (res: any) => {
            if (modalConfig.getAfterOpened()) {
              modalConfig.getAfterOpened()?.(res);
            }
          },
          error: (err: any) => {
            console.log(err);
          },
          complete: () => {},
        });

        this.modalRef
        .beforeClosed()
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (res: any) => {
            if (modalConfig.getBeforeClosed()) {
              modalConfig.getBeforeClosed()?.(res);
            }
          },
          error: (err: any) => {
            console.log(err);
          },
          complete: () => {},
        });
    }
  }
  
}
